import { Button, Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetMessageThreadByProductIdQuery } from "src/api/services/messagesApi";
import { Paths } from "src/constants/paths";
import WhiteCard from "src/shared/components/WhiteCard";

interface CardProps {
  productId: number | undefined;
}

const ChatCard = ({ productId }: CardProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const component = "subscription-details.chatCard";

  const { data } = useGetMessageThreadByProductIdQuery(
    productId ? productId : skipToken
  );

  const handleNavigation = useCallback(() => {
    if (data == null) return;

    navigate(`${Paths.MESSAGING}/${data?.slug}`);
  }, [data, navigate]);

  return (
    <WhiteCard gap={3}>
      <Typography variant="h6" fontWeight={600}>
        {t(`${component}.title`, "Need help?")}
      </Typography>
      <Stack direction="row" justifyContent="space-between">
        <Stack gap={1}>
          <Typography variant="subtitle2">
            {t(`${component}.subtitle`, "Medical Questions")}
          </Typography>
          <Typography>
            {t(`${component}.subtext`, "Chat with a provider")}
          </Typography>
        </Stack>
        <Button variant="contained" onClick={handleNavigation}>
          {t(`${component}.buttonText`, "Chat now")}
        </Button>
      </Stack>
    </WhiteCard>
  );
};

export default ChatCard;
